import Modal from "react-bootstrap/Modal";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faArrowRotateLeft, faPlus, faSave, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import CardObject from "../../../components/global/CardObject";
import { useDispatch, useSelector } from "react-redux";
import CardUser from "../../../components/global/CardUser";
import SrvButton from "../../../components/global/SrvButton";
import CardName from "../../../components/global/CardName";
import axios from "axios";
import CardDescription from "../../../components/card/CardDescription";
import ModalRemove from './ModalRemove';
import ButtonAction from "../../../components/global/ButtonAction";
import CardUserAvailable from "../../../components/card/CardUserAvailable";
import ModalAdd from "../../../components/modal/ModalAdd";
import ErrorAdd from "../../../util/ErrorAdd";

function ModalEdit({ model, show, onHide, id_parent }) {
    const dispatch = useDispatch()

    const stateParojectList = useSelector((state) => state.projectList);
    const stateSize = useSelector((state) => state.size);//Размеры окна

    const [loading, setLoading] = useState(false);
    const [log, setLog] = useState(false);

    //const [formName, setFormName] = useState(null);
    const [formDescription, setFormDescription] = useState(null);
    const [formObject, setFormObject] = useState([]);
    const [formUser, setFormUser] = useState([]);
    const [formObjectAll, setFormObjectAll] = useState(true);
    const [formUserAll, setFormUserAll] = useState(true);
    const [formStatus, setFormStatus] = useState(false);
    const [formParent, setFormParent] = useState(1);
    const [formId, setFormId] = useState(null);

    /******************************START РАЗМЕРЫ*********************************/
    const refHeader = useRef(null);//Шапка карточки
    const refFooter = useRef(null);//Footer карточки

    const [hightBody, setHightBody] = useState(0);

    useEffect(() => {
        if (refHeader.current !== undefined & refFooter.current !== undefined & stateSize.desktop !== true) {
            setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - refFooter.current.offsetHeight - 115)
        }
        if (refHeader.current !== undefined & stateSize.desktop === true) {
            setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - 120)
        }
    }, [refHeader, refFooter, stateSize, model, formObjectAll, formDescription]);
    /******************************END РАЗМЕРЫ*********************************/

    useEffect(() => {
        setFormId(model.ID);
        //setFormName(model.Name);
        setFormDescription(model.Description);
        setFormObjectAll(model.All_Object);
        setFormUserAll(model.All_User);
        setFormStatus(model.ID_Status);
        setFormParent(id_parent);

        const objects = stateParojectList.listObject.filter(a => a.ID_Project === model.ID).map(item => {
            return item.ID_Object;
        })
        setFormObject(objects);

        const users = stateParojectList.listUser.filter(a => a.ID_Project === model.ID).map(item => {
            return item.ID_User;
        })
        setFormUser(users);
    }, [model]);


    //Изменение объекта
    function objectHandler(checked, id) {
        if (checked == true) {
            setFormObject([...formObject.filter(a => a !== id), id]);
        }
        else {
            setFormObject([...formObject.filter(a => a !== id)]);
        }

        axios.post('/api_tracker/project/objectSet', { ID_Project: formId, ID_Object: id, Val: checked })
            .then((res) => {
                if (res.data.Status === 1) {
                    setFormStatus(1);
                    setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }
    //Изменение пользователей
    function userHandler(checked, id) {
        if (checked == true) {
            setFormUser([...formUser.filter(a => a !== id), id]);
        }
        else {
            setFormUser([...formUser.filter(a => a !== id)]);
        }

        axios.post('/api_tracker/project/userSet', { ID_Project: formId, ID_User: id, Val: checked })
            .then((res) => {
                if (res.data.Status === 1) {
                    setFormStatus(1);
                    setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    const [hideName, setHideName] = useState(false);
    const [logName, setLogName] = useState(null);
    const [loadingName, setLoadingName] = useState(false);
    function updateName(val) {
        setLoadingName(true);
        setLogName(null);

        if (val == null || val == '' || val == undefined) {
            setLogName('Введите название проекта');
            setLoadingName(false);
        }
        else {
            axios.post('/api_tracker/project/updateName', { ID_Project: formId, Name: val })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setFormStatus(1);
                        setLoadingName(false);
                        setHideName(true);
                    }
                    else {
                        setLogName(res.data.Error);
                        setLoadingName(false);
                    }
                })
                .catch((err) => {
                    setLogName('Неизвестная ошибка!');
                    setLoadingName(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    const [hideDescription, setHideDescription] = useState(false);
    const [logDescription, setLogDescription] = useState(null);
    const [loadingDescription, setLoadingDescription] = useState(false);
    function updateDescription(val) {
        setLoadingDescription(true);
        setLogDescription(null);

        axios.post('/api_tracker/project/updateDescription', { ID_Project: formId, Description: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setFormStatus(1);
                    setLoadingDescription(false);
                    setHideDescription(true);
                }
                else {
                    setLogDescription(res.data.Error);
                    setLoadingDescription(false);
                }
            })
            .catch((err) => {
                setLogDescription('Неизвестная ошибка!');
                setLoadingDescription(false);
                ErrorAdd(err, window.location.href);
            });
    }
    function updateObjectAll(val) {
        setLoading(true);
        setLog(null);
        setFormObjectAll(val);

        axios.post('/api_tracker/project/updateAllObject', { ID_Project: formId, All_Object: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setFormStatus(1);
                    setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }
    function updateUserAll(val) {
        setLoading(true);
        setLog(null);
        setFormUserAll(val);

        axios.post('/api_tracker/project/updateAllUser', { ID_Project: formId, All_User: val })
            .then((res) => {
                if (res.data.Status === 1) {
                    setFormStatus(1);
                    setLoading(false);
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }


    /***************************START АРХИВАЦИЯ****************************/
    const [modalArchiveShow, setModalArchiveShow] = useState(false);
    const [modalArchiveCancelShow, setModalArchiveCancelShow] = useState(false);
    const [logArchive, setLogArhive] = useState(null);
    const [loadingArchive, setLoadingArchive] = useState(false);

    function arhiveHandler() {
        setLoadingArchive(true);
        axios.post('/api_tracker/project/archive', { ID_Project: model.ID })
            .then((res) => {
                if (res.data.Status === 1) {
                    setModalArchiveShow(false);
                    onHide();
                }
                else {
                    setLogArhive(res.data.Error);
                    setLoadingArchive(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoadingArchive(false);
                ErrorAdd(err, window.location.href);
            });
    }
    function arhiveCancelHandler() {
        setLoadingArchive(true);

        axios.post('/api_tracker/project/archiveCancel', { ID_Project: model.ID })
            .then((res) => {
                if (res.data.Status === 1) {
                    setModalArchiveCancelShow(false);
                    onHide();
                }
                else {
                    setLogArhive(res.data.Error);
                    setLoadingArchive(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoadingArchive(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /****************************END АРХИВАЦИЯ*****************************/

    //const [modalAddShow, setModalAddShow] = useState(false);
    const [modalRemoveShow, setModalRemoveShow] = useState(false);

    /******************START ДОБАВЛЕНИЕ ДОЧЕРНЕГО ПРОЕКТА******************/
    const [modalAddShow, setModalAddShow] = useState(false);
    const [modalEditShow, setModalEditShow] = useState(false);

    const [loadingAdd, setLoadingAdd] = useState(false);
    const [logAdd, setLogAdd] = useState(null);
    const [modelAdd, setModelAdd] = useState(null);

    //Добавит новый проект
    function addHandler(name) {
        setLoadingAdd(true);
        setLogAdd(null);

        axios.post('/api_tracker/project/add', { ID_Parent: formId, Name: name, Description: null, All_Object: true, All_User: true })
            .then((res) => {
                if (res.data.Status === 1) {
                    getNew(res.data.Data);
                }
                else {
                    setLogAdd(res.data.Error);
                    setLoadingAdd(false);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }

    //Откроет новый проект в модальном окне
    function getNew(id) {

        axios.get('/api_tracker/project/get', { params: { ID: id } })
            .then((res) => {
                if (res.data.Status == 1) {
                    setModelAdd(res.data.Data);
                    setModalAddShow(false);
                    setModalEditShow(true);
                    setLoadingAdd(false);
                }
                else {
                    setLoadingAdd(false);
                    setLogAdd(res.Error);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }
    /*******************END ДОБАВЛЕНИЕ ДОЧЕРНЕГО ПРОЕКТА*******************/

    return (
        <>
            {stateSize.desktop === true ? (
                <Modal show={show} onHide={onHide} size="lg">
                    <Modal.Body className="modal_min_height_350">
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="row">
                            <div className="col-md-7">
                                <div ref={refHeader}>
                                    <CardName name={model.Name} onlyRead={false} placeholder='Введите название проекта...' updateHandler={updateName} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                    <small className="mb-3" style={{ opacity: '0.5' }}>ID: {model.ID}</small>
                                </div>
                                <div className="mb-3" style={{ maxHeight: hightBody, overflow: 'auto' }}>
                                    <CardDescription text={formDescription} rows={5} placeholder="Описание..." updateHandler={updateDescription} loading={loadingDescription} log={logDescription} hide={hideDescription} setHide={setHideDescription} />
                                </div>
                            </div>
                            <div className="col-md-5">
                                <>
                                    <div className="card-block-title">Действия</div>
                                    <div key={formStatus} className="btn_block_footer">
                                        {formStatus === 1 ? (
                                            <>
                                                <div><ButtonAction typeBtn='add' textBtn='Дочерний проект' onClick={() => setModalAddShow(true)} /></div>
                                                <div className="mt-10"><ButtonAction typeBtn='archive' textBtn='Архив' onClick={() => setModalArchiveShow(true)} /></div>
                                                <div className="mt-10"><ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} /></div>
                                            </>
                                        ) : (
                                            <div className="mt-10"><ButtonAction typeBtn='cancel' onClick={() => setModalArchiveCancelShow(true)} /></div>
                                        )}
                                    </div>
                                    <div className="card-block-title mt-20">ДОСТУПНЫЕ ОБЪЕКТЫ</div>
                                    <div className="mt-15">
                                        <CardObject checkedList={formObject} changeHandler={objectHandler} all={formObjectAll} allHandler={(val) => updateObjectAll(val)} />
                                    </div>
                                    <div className="card-block-title mt-20">ДОСТУПНЫЕ ПОЛЬЗОВАТЕЛИ</div>
                                    <div className="mb-15">
                                        <CardUserAvailable checkedList={formUser} changeHandler={userHandler} all={formUserAll} allHandler={(val) => updateUserAll(val)} maxShow={2} />
                                    </div>
                                </>
                            </div>
                        </div>
                        {log != null && (
                            <div className="form_error text-center">
                                {log}
                            </div>
                        )}
                    </Modal.Body>
                </Modal>
            ) : (
                <Modal show={show} onHide={onHide} size="lg">
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="row">
                            <div ref={refHeader}>
                                <div className="mt-10">
                                    <CardName name={model.Name} onlyRead={false} placeholder='Введите название проекта...' updateHandler={updateName} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                                </div>
                                <small className="mb-3" style={{ opacity: '0.5' }}>ID: {model.ID}</small>
                            </div>
                            <div className="mb-3" style={{ maxHeight: hightBody, overflow: 'auto' }}>
                                <CardDescription text={formDescription} rows={5} placeholder="Описание..." updateHandler={updateDescription} loading={loadingDescription} log={logDescription} hide={hideDescription} setHide={setHideDescription} />
                            </div>
                            <div ref={refFooter}>
                                {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                                <>
                                    <div className="card-block-title mt-10">ДОСТУПНЫЕ ОБЪЕКТЫ</div>
                                    <div className="">
                                        <CardObject checkedList={formObject} changeHandler={objectHandler} all={formObjectAll} allHandler={setFormObjectAll} />
                                    </div>
                                    <div className="card-block-title mt-0">ДОСТУПНЫЕ ПОЛЬЗОВАТЕЛИ</div>
                                    <div className="mb-20">
                                        <CardUserAvailable checkedList={formUser} changeHandler={userHandler} all={formUserAll} allHandler={setFormUserAll} maxShow={2} />
                                    </div>
                                    <hr></hr>
                                    <div key={formStatus} className="m_btn_block_footer">
                                        {formStatus === 1 ? (
                                            <>
                                                <div><ButtonAction typeBtn='add' textBtn='Проект' onClick={() => setModalAddShow(true)} /></div>
                                                <div><ButtonAction typeBtn='archive' textBtn='Архив' onClick={() => setModalArchiveShow(true)} /></div>
                                                <div><ButtonAction typeBtn='remove' onClick={() => setModalRemoveShow(true)} /></div>
                                            </>
                                        )
                                            :
                                            (
                                                <div className="mt-10"><ButtonAction typeBtn='cancel' onClick={() => setModalArchiveCancelShow(true)} /></div>
                                            )}
                                    </div>
                                </>
                            </div>
                        </div>

                        {log != null && (
                            <div className="form_error text-center">
                                {log}
                            </div>
                        )}
                    </Modal.Body>
                </Modal>
            )}

            {modalArchiveShow === true && (
                <Modal show={modalArchiveShow} onHide={() => setModalArchiveShow(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center mb-15">Архивирование задачи</div>
                        <div className="mt-15 text-center">
                            Подтвердите архивирование задачи <b>«{model.Name}»</b> <br></br>
                            <b className="alert-warning">Внимание!</b> Все дочерние проекты также будут перенесены в архив!
                        </div>
                        {logArchive !== null && <div className="form_error text-center mt-15">{logArchive}</div>}
                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="archive" size='lg' loading={loadingArchive} onClick={() => arhiveHandler()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal >
            )}
            {modalArchiveCancelShow === true && (
                <Modal show={modalArchiveCancelShow} onHide={() => setModalArchiveCancelShow(false)} >
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center mb-15">Отмена архивирование задачи</div>
                        <div className="mt-15 text-center">Подтвердите отмену архивирование задачи <b>«{model.Name}»</b></div>
                        {logArchive !== null && <div className="form_error text-center mt-15">{logArchive}</div>}
                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="cancel" size='lg' loading={loadingArchive} onClick={() => arhiveCancelHandler()} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal >
            )}
            {modalAddShow === true && (
                <ModalAdd show={modalAddShow} onHide={() => { setModalAddShow(false); setLogAdd(null) }} title="Добавление дочернего проекта" error={logAdd} loading={loadingAdd} updateHandler={addHandler} />
            )}
            {modalEditShow === true && (
                <ModalEdit show={modalEditShow} onHide={() => setModalEditShow(false)} model={modelAdd} />
            )}
            {modalRemoveShow === true && (
                <ModalRemove show={modalRemoveShow} onHide={() => setModalRemoveShow(false)} onHideMain={onHide} model={model} />
            )}
        </>
    );
}
export default ModalEdit;
